import classNames from 'classnames'
import type { FC } from 'react'
import React, { useMemo } from 'react'

import { useTabsContext } from './tabs-context'
import type { TabIndicatorProps } from './types'
import { TAB_THEME_KEY } from './types'
import { transitions } from '../../themes/theme-keys/transitions'
import { BoxPrivate } from '../_primitives/box/box'

const TabIndicator: FC<TabIndicatorProps> = React.forwardRef<
  HTMLDivElement,
  TabIndicatorProps
>(function TabIndicator(props, ref) {
  const {
    variant = 'indicator',
    className,
    orientation,
    indicatorPosition,
    disableAnimation,
    ...other
  } = props
  const { variant: tabVariant } = useTabsContext()
  const _indicatorPosition =
    orientation === 'vertical'
      ? indicatorPosition === 'left' || indicatorPosition === 'right'
        ? indicatorPosition
        : 'right'
      : indicatorPosition === 'top' || indicatorPosition === 'bottom'
        ? indicatorPosition
        : 'bottom'

  const __css = useMemo(
    () => ({
      position: 'absolute',
      transition: disableAnimation ? 'initial' : transitions.create(),
      ...(orientation === 'vertical'
        ? {
            height: '100%',
            width: '0.2em',
            ...(_indicatorPosition === 'right' ? { right: 0 } : { left: 0 })
          }
        : {
            height: '0.2em',
            ...(_indicatorPosition === 'bottom' ? { bottom: 0 } : { top: 0 }),
            width: '100%'
          })
    }),
    [_indicatorPosition, disableAnimation, orientation]
  )
  return (
    <BoxPrivate
      as="span"
      ref={ref}
      variant={tabVariant ? `${tabVariant}.${variant}` : variant}
      __themeKey={TAB_THEME_KEY}
      className={classNames(
        'csg-tui-tab-indicator',
        {
          'is-vertical': orientation === 'vertical'
        },
        className
      )}
      {...other}
      __css={__css}
    />
  )
})

export default TabIndicator
